import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/HeaderFooter/Footer";
import { AuthService } from "../services/authService";
import "../styles/Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [keepSignedIn, setKeepSignedIn] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already logged in
    const authToken = localStorage.getItem("authToken");
    const keepSignedInFlag = localStorage.getItem("keepSignedIn");

    if (authToken && keepSignedInFlag) {
      navigate("/dashboard");
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      // Clear localStorage before logging in
      localStorage.clear();

      const data = await AuthService.login(email, password);

      // Store token or relevant data in localStorage
      localStorage.setItem("authToken", data.token);
      localStorage.setItem("loggedInUserEmail", email);

      if (keepSignedIn) {
        localStorage.setItem("keepSignedIn", true);
      }

      // Navigate to dashboard on successful login
      navigate("/dashboard");

    } catch (err) {

      const errorMessages = {
        401: "Incorrect email or password. Please try again.",
        404: "Service not available. Please try again later.",
        500: "Internal server error. Please try again later.",
        default: "An unexpected error occurred. Please try again."
      };

      const message = errorMessages[err.response?.status] || err.message || errorMessages.default;
      
      setError(message);

    } finally {
      setLoading(false); 
    }
  };

  const handleForgotPassword = () => {
    navigate("/forgotpassword");
  };

  return (
    <div className="login-page">
      <div className="content-wrapper">
        <div className="logo">
          <img src="/images/logo.png" alt="Caliber Logo" />
        </div>

        <div className="login-card">
          <h1 className="welcome">Welcome to Caliber</h1>
          <p className="subtitle">We are glad to have you on our team!</p>
          <hr className="divider" />

          <form onSubmit={handleLogin} id="loginForm">
            <div className="input-row">
              <div className="input-group">
                <div className="password-group">
                  <label htmlFor="email">Email</label>
                </div>
                <input type="text" id="email" placeholder="Enter Email" value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              
              <div className="input-group">
                <div className="password-group">
                  
                  <label htmlFor="password">Password</label>

                  <a onClick={handleForgotPassword} className="forgot-password" > Forgot Password? </a>
                </div>

                <input type="password" id="password" placeholder="Enter Password" value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />

              </div>
            </div>

            {error && <p style={{ color: "red" }}>{error}</p>}

            <div className="bottom-row">
              
              <div className="custom-checkbox">
                <input type="checkbox" id="keepSignedIn" checked={keepSignedIn} onChange={(e) => setKeepSignedIn(e.target.checked)} />
                <label htmlFor="keepSignedIn"></label>
                <span className="custom-checkbox-text">Keep me signed in</span>
              </div>
              
              <button type="submit" className="sign-in-btn">
                Sign In
              </button>

            </div>
          </form>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Login;
